// extracted by css-extract-rspack-plugin
export default {"fileError":"AttachmentsForm__fileError--bu2Gh"};